/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import {
  humps,
  siteService,
  useAppSelector,
} from '@lib/index';
import { ROLES } from '@config/index';
import { assignContractor } from '@features/account/AccountSlice';
import { EmployerDataProps } from './types';
import { useAppDispatch } from './redux.hooks';

export const useSwitchEmployers = () => {
  const dispatch = useAppDispatch();
  const { currentUser } = useAppSelector((state) => state.account);
  const isAdmin = currentUser.role === ROLES.admin;
  const { contractorId, siteId } = currentUser;
  const { useGetEmployersQuery } = siteService;
  const { data: employers, isLoading: siteEmployersLoading } = useGetEmployersQuery(
    siteId as number,
    { skip: isAdmin, refetchOnMountOrArgChange: true },
  );
  const siteEmployers = humps(employers) as EmployerDataProps[];
  const hasEmployers = siteEmployers?.length > 1;

  // Si un general_admin le quita/cambia los employers a este contractor desde
  // otra sesión, el contractorId seleccionado acá puede dejar de existir en
  // la lista vigente. Sin esto, las vistas que confían en `contractorId`
  // (dashboards, listas de workers) siguen mostrando datos de un employer
  // que ya no está disponible, sin ningún indicio de que algo cambió.
  useEffect(() => {
    if (!siteEmployers?.length) return;
    const isStillValid = siteEmployers.some((employer) => employer.id === contractorId);
    if (!isStillValid) {
      dispatch(assignContractor(siteEmployers[0].id));
    }
  }, [siteEmployers, contractorId, dispatch]);

  return {
    siteEmployers,
    contractorId,
    hasEmployers,
    siteEmployersLoading,
  };
};
